import { Icon } from '@lib/iab/iab-vast-model';

import createIconClicks from './icon-clicks';
import createResource from './resource';
import hasValue from '../util/has-value';
import isNonEmptyArray from '../util/is-non-empty-array';

interface UnmarshalerNode {
    _value: unknown;
    [key: string]: unknown;
}

const parsePosition = (
    str: string | null,
    allowed: string[]
): string | number | null =>
    str == null ? str : allowed.indexOf(str) < 0 ? parseInt(str, 0) : str;

const createIcon = ($icon: UnmarshalerNode): Icon => {
    const icon = new Icon();
    icon.program = $icon.program as string;
    icon.width = $icon.width as number;
    icon.height = $icon.height as number;
    icon.xPosition = parsePosition($icon.xPosition as string, [
        'left',
        'right',
    ]);
    icon.yPosition = parsePosition($icon.yPosition as string, [
        'top',
        'bottom',
    ]);
    icon.duration = $icon.duration as number;
    icon.offset = $icon.offset as number;
    icon.apiFramework = $icon.apiFramework as string;
    icon.pxratio = $icon.pxratio as string;
    icon.resource = createResource($icon);

    if (
        $icon.iconClicks != null &&
        (hasValue(($icon.iconClicks as UnmarshalerNode).iconClickThrough) ||
            isNonEmptyArray(
                ($icon.iconClicks as UnmarshalerNode).iconClickTracking
            ))
    ) {
        icon.clicks = createIconClicks($icon.iconClicks as UnmarshalerNode);
    }

    if ($icon.iconViewTracking != null) {
        icon.viewTrackings.push(
            ...($icon.iconViewTracking as UnmarshalerNode[])
                .filter(hasValue)
                .map((click: UnmarshalerNode) => click._value as string)
        );
    }

    return icon;
};

export default createIcon;
